import React from 'react';

const UpworkReviews = () => {
  const reviews = [
    {
      id: 1,
      image: '/assets/reviews/review-4-51-40_pm.webp',
      alt: 'Hiring for Online Email Marketing Manager using Kit.com - 5.0 rating'
    },
    {
      id: 2,
      image: '/assets/reviews/review-4-52-00_pm.webp',
      alt: 'Kit.com Campaign Automation Expert - 5.0 rating'
    },
    {
      id: 3,
      image: '/assets/reviews/review-4-52-06_pm.webp',
      alt: 'Looking For An Email Marketer To Evaluate and Adjust Marketing Funnels - 5.0 rating'
    },
    {
      id: 4,
      image: '/assets/reviews/review-4-52-17_pm.webp',
      alt: 'Badassery wanted! Email and social engagement, Kit.com - 4.5 rating'
    },
    {
      id: 5,
      image: '/assets/reviews/review-4-52-43_pm.webp',
      alt: 'Email Marketing for Land Company - 5.0 rating'
    },
    {
      id: 6,
      image: '/assets/reviews/review-4-51-35_pm.webp',
      alt: 'Kit.com Migration & Email Marketing - 5.0 rating'
    },
    {
      id: 7,
      image: '/assets/reviews/review-4-51-26_pm.webp',
      alt: '60 minute consultation - 5.0 rating'
    },
    {
      id: 8,
      image: '/assets/reviews/review-4-51-18_pm.webp',
      alt: 'Wordpress/Leadpages/Kit.com Consultant needed - 5.0 rating'
    },
    {
      id: 9,
      image: '/assets/reviews/review-4-51-12_pm.webp',
      alt: 'ActiveCampaign Automation Expert - 5.0 rating'
    },
    {
      id: 10,
      image: '/assets/reviews/review-4-50-59_pm.webp',
      alt: 'Active Campaign optimization and administration - 5.0 rating'
    },
    {
      id: 11,
      image: '/assets/reviews/review-4-50-53_pm.webp',
      alt: 'ActiveCampaign Expert - 5.0 rating'
    },
    {
      id: 12,
      image: '/assets/reviews/review-4-50-47_pm.webp',
      alt: 'ManyChat Setup for list building & sales - 4.6 rating'
    },
    {
      id: 13,
      image: '/assets/reviews/review-4-50-39_pm.webp',
      alt: 'Convert Kit specialist for email automation review - 5.0 rating'
    },
    {
      id: 14,
      image: '/assets/reviews/review-4-50-33_pm.webp',
      alt: 'Convert Kit specialist for email automation - 5.0 rating'
    },
    {
      id: 15,
      image: '/assets/reviews/review-4-50-28_pm.webp',
      alt: 'ActiveCampaign Funnel & ManyChat Automation Expert - 5.0 rating'
    },
    {
      id: 16,
      image: '/assets/reviews/review-4-50-21_pm.webp',
      alt: 'Marketing Manager for a Podcast Brand - 5.0 rating'
    }
  ];

  // Duplicate the reviews array for seamless infinite scroll
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <section className="section bg-cream overflow-hidden pt-24 md:pt-32" data-testid="upwork-reviews">
      <div className="container-x mb-14">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.25em] text-[var(--gh-orange)] font-semibold">
              In their own words
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold mt-3 text-ink leading-[1.05]">
              Sixteen 5-star outcomes,{' '}
              <span className="font-serif italic text-[var(--gh-orange)]">verified on Upwork</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-muted-warm">
            Every review below is a real client outcome — pulled directly from my Upwork
            profile. Hover or scroll to read the full story.
          </p>
        </div>
      </div>

      <div className="relative overflow-hidden">
        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--gh-cream)] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--gh-cream)] to-transparent z-10" />

        <div className="flex gap-6 animate-scroll-reviews-fast whitespace-nowrap">
          {duplicatedReviews.map((review, index) => (
            <div
              key={`${review.id}-${index}`}
              data-testid={`review-card-${index}`}
              className="flex-shrink-0 w-[85vw] sm:w-[420px] md:w-[520px] rounded-3xl overflow-hidden border border-line bg-white shadow-[0_20px_40px_-25px_rgba(10,10,10,0.18)] hover:shadow-[0_30px_60px_-30px_rgba(234,88,12,0.4)] transition-shadow"
            >
              <img
                src={review.image}
                alt={review.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-auto object-contain bg-white"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpworkReviews;
